/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import compressImage from '../../utils/compressImage';

export const getDonationProgram = async (params) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/program/datatable`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
};

export const getProgramDonationById = async (id) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/program/${id}`);
    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
};

export const AddDonationData = async (data) => {
  try {
    const imageFile = data.get('image');
    if (imageFile && imageFile instanceof File) {
      const compressedFile = await compressImage(imageFile);
      if (compressedFile) {
        data.set('image', compressedFile);
      }
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/program/add`, {
      method: 'POST',
      body: data,
    });
    return response;
  } catch (error) {
    console.error('Error in AddDonationData:', error);
    return error;
  }
};

export const updateDonationById = async (id, data) => {
  try {
    const imageFile = data.get('image');
    if (imageFile && imageFile instanceof File) {
      const compressedFile = await compressImage(imageFile);
      if (compressedFile) {
        data.set('image', compressedFile);
      }
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/program/${id}`, {
      method: 'PUT',
      body: data,
    });
    return response;
  } catch (error) {
    console.error('Error in updateDonationById:', error);
    return error;
  }
};

export const AddStoryImage = async (data) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/program/story_description_image`, {
      method: 'POST',
      body: data,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const getAdmissionDonation = async (params) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/admission/datatable`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
};

export const getAdmissionDonationById = async (id) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/admission/${id}`);
    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
};

export const printNotaAdmissionDonationById = (id) => {
  try {
    return (`${process.env.REACT_APP_API_URL}api/donation/admission/print_bills/${id}`);
  } catch (error) {
    return error;
  }
};

export const getPencairanDanaById = async (id) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/usage/disbursement/${id}`);
    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
};

export const getPenyaluranDanaById = async (id) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/usage/distribution/${id}`);
    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
};

export const getDisbursementDonation = async (params) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/usage/disbursement/datatable`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
};

export const getDistributionDonation = async (params) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/usage/distribution/datatable`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
};

export const getAllProgramDonation = async (param) => {
  try {
    const type = param ? `?distribution=${param}` : '';
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/program${type}`);
    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
};

export const addDonationDisbursement = async (data) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/usage/disbursement/add`, {
      method: 'POST',
      body: data,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const updateDisbursementDanaById = async (id, data) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/usage/disbursement/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const DeleteDonationDisbursement = async (id) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/usage/disbursement/${id}`, {
      method: 'DELETE',
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const addDonationDistribution = async (data) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/usage/distribution/add`, {
      method: 'POST',
      body: data,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const updateDistributionById = async (id, data) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/usage/distribution/${id}`, {
      method: 'PUT',
      body: data,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const DeleteDonationDistribution = async (id) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}api/donation/usage/distribution/${id}`, {
      method: 'DELETE',
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const exportAdmission = async (param) => {
  try {
    const params = new URLSearchParams(param);
    const url = `${process.env.REACT_APP_API_URL}api/donation/admission/export?${params.toString()}`;
    const admissions = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });

    const blob = await admissions.blob();
    const admissionUrlDownload = window.URL.createObjectURL(blob);
    const startDate = moment(param.get('rangeStart')).format('DD');
    const endDate = moment(param.get('rangeEnd')).format('DD MMMM YYYY');

    const a = document.createElement('a');
    a.href = admissionUrlDownload;
    a.download = `Penerimaan Donasi ${startDate} - ${endDate}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(admissionUrlDownload);
    return { success: true, message: 'File download started' };
  } catch (error) {
    return error;
  }
};

export const exportDonationUsage = async (param, type) => {
  try {
    const params = new URLSearchParams(param);
    const url = `${process.env.REACT_APP_API_URL}api/donation/usage/${type}/export?${params.toString()}`;
    const usages = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });

    const blob = await usages.blob();
    const usageUrlDownload = window.URL.createObjectURL(blob);
    const startDate = moment(param.get('rangeStart')).format('DD');
    const endDate = moment(param.get('rangeEnd')).format('DD MMMM YYYY');

    const a = document.createElement('a');
    a.href = usageUrlDownload;
    a.download = `Pencairan Dana ${startDate} - ${endDate}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(usageUrlDownload);
    return { success: true, message: 'File download started' };
  } catch (error) {
    return error;
  }
};
